import React from 'react';
import { Platform, View, ScrollView, ImageBackground, StyleSheet, Image, Text } from 'react-native'
import { Header } from 'react-native-elements'
import defaultBackground from '../../images/bg-tile.png'
// import { connect } from 'react-redux'
import HeaderRight from '../header-right'
import { TouchableOpacity } from 'react-native-gesture-handler';
import chev from '../../images/chev.png'
import ImageBackgroundWeb from '../web/ImageBackground'
import TextZ from '../TextZ';
import { Icon } from 'react-native-elements/dist/icons/Icon';

const CoverBackground = Platform.OS === 'web' ? ImageBackgroundWeb : ImageBackground;
const Container =  Platform.OS === 'web' ? View : ImageBackground;
const ViewContainer = Platform.OS === 'web' ? View : ScrollView;
const containerStyle =  Platform.OS === 'web' ? { maxWidth: 1024, margin: 'auto', marginTop: 0, marginBottom: 0, width: '100%' } : {width: '100%', height: '100%'};

export default ({ children, onSetting, onToggleSA, background, logo, title, subtitle, onClickLogo }) => {
    return <ViewContainer style={styles.container}>
        <CoverBackground
            source={background || defaultBackground}
            style={{width: '100%', height: '100%' }}
            imageStyle={{ resizeMode: background ? 'cover' : 'repeat', backgroundAttachment: 'fixed' }}>
            <Header
                centerContainerStyle={containerStyle}
                placement="left"
                centerComponent={<TouchableOpacity onPress={onClickLogo || (() => {})} style={{ flexDirection: 'column', justifyContent: 'center'}}>
                  <View style={{ flexDirection: 'row', justifyContent: 'center'}}>
                    {onClickLogo ? <Icon name='chevron-left' size={18} color='#ffffff'/> : null}
                    <TextZ style={{color: '#ffffff'}}>{title}</TextZ>
                  </View>
                  <TextZ style={{color: '#ffffff', textAlign: 'center', color: 'gold' }}>{subtitle}</TextZ>

                </TouchableOpacity>}
                leftComponent={<TouchableOpacity onPress={onClickLogo || (() => {})}><Image source={logo} style={{width: 50, height: 50}}/></TouchableOpacity>}
                // rightComponent={{ icon: 'settings', color: '#fff', onPress: onSetting }}
                rightComponent={<HeaderRight 
                    onSetting={onSetting}
                    onToggleSA={onToggleSA}
                />}
                backgroundColor="rgba(0,0,0,0.7)"
            />
            <Container style={containerStyle}>
                {children}
            </Container>
        </CoverBackground>
    </ViewContainer>
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        flexDirection: 'column',
        alignContent: 'flex-start',
    },
});
  
  